import 'babel-polyfill';
/**
 * @file This is the main project file where all other scripts should be initiated.
 *
 * Note that since this file will be appended to the `body` element there is no need
 * to wait for the DOMContentLoaded event before initiating your scripts. In fact, it
 * will not work since the DOMContentLoaded event will have been triggered before this
 * file is loaded. Instead use an iife (1) or, as in the example below, a function
 * that is called when a custom event is triggered.
 *
 * 1. https://en.wikipedia.org/wiki/Immediately-invoked_function_expression
 *
 * Examples
 *
 * Load a self-initiating script that does not expect a DOMContentLoaded event:
 * import './path/to/script.js'
 *
 * Load a script that you need to send parameters to or initiate at a specific time:
 * First import the script:
 * import functionName from './path/to/script.js'
 * Note that the path needs to start with './' and be relative to your code root, which
 * is 'project' by default.
 * Then initiate it:
 * functionName(param);
 *
 * See the included examples for more.
 */
import './js/vendor/polyfills/polyfill-custom-event.js';

import scrollableElement from './components/scrollable-element/c-scrollable-element.js';
import './components/header/c-header.js';
import './components/accordion/c-accordion.js';
import './components/button/c-button.js';
import './components/hero-carousel/c-hero-carousel.js';
import './components/event-carousel/c-event-carousel.js';
import './components/form-elements/form/c-form.js';
import formMap from './components/form-elements/form-map/c-form-map.js';
import './components/news-grid/c-news-grid.js';
import './components/tabs/c-tabs.js';
import './components/compare/c-compare.js';
import './components/compare-table/c-compare-table.js';
import './components/post-list/c-post-list.js';
import './components/navigation/sub-navigation/c-sub-navigation.js';
import './components/pop-out/c-pop-out.js';
import './components/navigation/categories/c-categories.js';
import './components/steps/c-steps.js';
import './components/chat/c-chat.js';
import './components/get-more/c-get-more.js';
import './components/chart/c-chart.js';
import './components/iframe/c-iframe.js';
import autocomplete from './components/form-elements/autocomplete/c-autocomplete.js';
import './js/utilities/track/u-track.js';
import { deltaFilters, deltaSort } from './pages/delta/delta.js';

deltaFilters();
deltaSort();

document.addEventListener('newcontent', (e) => {
	scrollableElement(e.target.querySelectorAll('table:not(.not-scrollable)'));

	// Init autocomplete
	autocomplete(document.querySelectorAll('.c-autocomplete__input'));

	// Init form map
	if (document.querySelectorAll('#form-map').length > 0){
		formMap('form-map');
	};
});

document.dispatchEvent(new CustomEvent('newcontent'));



// WEBPACK FOOTER //
// ./main-temp.js